import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {Card, CardTitle, CardText, CardMedia} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton'

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { APP_CONSTANTS } from '../constants';

const muiTheme = getMuiTheme({
    fontFamily: 'Lato, sans-serif',
    palette: {
        primary1Color: APP_CONSTANTS.COLORS.BRAND_PRIMARY,
        primary2Color: APP_CONSTANTS.COLORS.BRAND_SECONDARY,
        accent1Color: APP_CONSTANTS.COLORS.BRAND_ACCENT
    }
});

const STORAGE_TYPES = APP_CONSTANTS.CALCULATOR.STORAGE_TYPES;
const IMAGES = APP_CONSTANTS.CALCULATOR.STORAGE_IMAGES;
const SIZES = APP_CONSTANTS.CALCULATOR.SIZES;
const PRICES = APP_CONSTANTS.CALCULATOR.PRICE_ESTIMATES;

class Calculator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            storage_type: STORAGE_TYPES[5],
            index: 5,
            price: PRICES[5]
        };

        this.handleStorageType = (event, index, value) => {
            this.setState({storage_type: value, index: index, 'price': PRICES[index]})
            gtag('event', 'click', {
                'category': 'Earnings Calculator',
                'label': value
            });
        }

        this.earnings = () => {
            return `$${this.state.price} per week`;
        }
    }

    componentDidMount() {
        // Component initialization
    }

    render() {
        // Custom styles matching your site's design
        const containerStyle = {
            background: '#f5f5f5',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            marginBottom: '30px',
            display: 'flex',
            flexDirection: 'column', // Default to column for mobile
            height: 'auto' // Let height adjust based on content
        };

        const leftPanelStyle = {
            padding: '20px 25px',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: 'auto', // Auto height
            minHeight: '380px' // Minimum height
        };

        const titleStyle = {
            fontSize: '22px',
            fontWeight: '700',
            color: '#333',
            marginBottom: '12px',
            lineHeight: '1.2'
        };

        const selectFieldStyle = {
            width: '100%',
            marginBottom: '18px'
        };

        const floatingLabelStyle = {
            color: '#FD9744',  // Changed from #4252b2 to primary1 color
            fontSize: '14px',
            fontWeight: '600',
            textAlign: 'left'
        };

        const earningsContainerStyle = {
            textAlign: 'center',
            padding: '15px 15px',
            background: 'linear-gradient(135deg, #f8faff 0%, #fff 100%)',
            borderRadius: '8px',
            border: '2px solid #e5e8f1',
            marginTop: '10px'
        };

        const earningsTextStyle = {
            fontSize: '18px',
            fontWeight: '700',
            color: '#333',
            marginBottom: '10px',
            lineHeight: '1.3'
        };

        const buttonStyle = {
            backgroundColor: '#FF6F61',
            color: '#fff',
            height: '45px',
            borderRadius: '6px',
            fontWeight: '600',
            textTransform: 'uppercase',
            fontSize: '13px',
            minWidth: '200px',
            boxShadow: '0 4px 15px rgba(255, 111, 97, 0.3)'
        };

        const buttonLabelStyle = {
            lineHeight: '45px',
            fontWeight: '600'
        };

        const disclaimerStyle = {
            fontSize: '11px',
            color: '#666',
            fontStyle: 'italic',
            marginTop: '12px'
        };

        const imageOverlayStyle = {
            background: 'linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.3))',
            position: 'absolute',  // Position absolute for overlay
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            padding: '18px',
            zIndex: 10  // Ensure overlay is on top
        };

        const overlayTitleStyle = {
            fontSize: '26px',
            fontWeight: '700',
            color: '#ffffff',
            marginBottom: '4px'
        };

        const overlaySubtitleStyle = {
            fontSize: '15px',
            color: 'rgba(255,255,255,0.9)',
            fontWeight: '600'
        };

        // Add responsive image container style
        const imageContainerStyle = {
            position: 'relative',
            height: '380px', // Fixed height for image container
            overflow: 'hidden',
            width: '100%'
        };
        
        const imageStyle = {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
        };

        // Add media query for desktop
        const mediaQueryStyles = window.matchMedia('(min-width: 768px)').matches ? {
            container: {
                flexDirection: 'row',
                height: '380px'
            },
            leftPanel: {
                height: '100%'
            },
            row: {
                flexDirection: 'row' // Add this to control row direction
            }
        } : {
            row: {
                flexDirection: 'column' // Explicitly set column for small screens
            }
        };

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="calculator-container" style={{marginBottom: '50px'}}>
                    <div style={{...containerStyle, ...mediaQueryStyles.container}}>
                        {/* Remove the hardcoded flexDirection from here and use the responsive one */}
                        <div className="row" style={{
                            margin: 0, 
                            width: '100%', 
                            display: 'flex',
                            flexDirection: mediaQueryStyles.row.flexDirection
                        }}>
                            <div className="col-xs-12 col-md-5" style={{padding: 0}}>
                                <div style={{...leftPanelStyle, ...mediaQueryStyles.leftPanel}}>
                                    <h2 style={titleStyle}>Calculate Your Earnings</h2>
                                    
                                    <SelectField 
                                        floatingLabelText="Select Your Storage Type"
                                        floatingLabelStyle={floatingLabelStyle}
                                        selectedMenuItemStyle={{color: '#FD9744'}}
                                        value={this.state.storage_type} 
                                        onChange={this.handleStorageType}
                                        style={{...selectFieldStyle, textAlign: 'left'}}
                                        underlineStyle={{borderColor: '#FD9744'}}
                                        underlineFocusStyle={{borderColor: '#FD9744'}}
                                    >
                                        {STORAGE_TYPES.map((el, i) => 
                                            <MenuItem 
                                                value={el} 
                                                key={i} 
                                                primaryText={`${el} (${SIZES[i]} sq.m.)`}
                                                style={{fontSize: '15px'}}
                                            />
                                        )}
                                    </SelectField>

                                    <div style={earningsContainerStyle}>
                                        <div style={earningsTextStyle}>
                                            You could earn<br />
                                            <span style={{color: '#FD9744', fontSize: '22px'}}>
                                                {this.earnings()}
                                            </span>
                                        </div>
                                        
                                        <RaisedButton 
                                            label="List Your Space for Free" 
                                            primary={false}
                                            backgroundColor="#FF6F61"
                                            labelColor="#ffffff"
                                            href="/dashboard/create-listing"
                                            style={{marginBottom: '15px', borderRadius: '6px'}}
                                            buttonStyle={buttonStyle}
                                            labelStyle={buttonLabelStyle}
                                            overlayStyle={{borderRadius: '6px'}}
                                            disableFocusRipple={true}
                                            rippleStyle={{borderRadius: '6px'}}
                                        />
                                        
                                        <div style={disclaimerStyle}>
                                            *This figure is an estimate only. Actual earnings may vary.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-xs-12 col-md-7" style={{padding: 0, display: 'flex', height: '100%'}}>
                                <div style={{...imageContainerStyle, flex: 1}}>
                                    <img 
                                        src={IMAGES[this.state.index]}
                                        alt={this.state.storage_type}
                                        style={imageStyle}
                                    />
                                    <div style={imageOverlayStyle}>
                                        <h3 style={overlayTitleStyle}>
                                            {this.state.storage_type}
                                        </h3>
                                        <p style={overlaySubtitleStyle}>
                                            Earn {this.earnings()} with your {this.state.storage_type.toLowerCase()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default Calculator;
